import axios from "axios";
import { isEmpty, trim } from "lodash";
import moment from "moment";
import React, { useEffect, useReducer, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Link, useNavigate } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import Loader from "../../Components/Global/Loader";
import DashboardLayouts from "../../Components/Layout/DashboardLayouts";
import { useAuth } from "../../Context/AuthContext";
import DummyImg from "../../Public/Images/568165.png";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import GallaryBox from "../../Components/Global/GallaryBox";
import DeleteModal from "../../Components/Global/modal/DeleteModal";
import PaymentModal from "../../Components/Global/modal/PaymentModal";
import useAuthentication from "../../hooks/useAuthentication";
import useMultipleImgUpload from "../../hooks/useMultipleImgUpload";
import useSearchListPagination from "../../hooks/useSearchListPagination";
function Tenantdashboard({ allowedRoles }) {
  const { allowLoading } = useAuthentication(allowedRoles);

  const initialState = {
    task_title: "",
    task_category: "",
    sub_task_category: "",
    issue_date: "",
    receiver: [],
    description: "",
    allReceivers: [],
  };

  const updateStateFunc = (state, action) => {
    switch (action.type) {
      case "input":
        return {
          ...state,
          [action.payload.target.name]: action.payload.target.value,
        };
      case "checkbox":
        return {
          ...state,
          receiver: action.payload.target.checked
            ? [...state.receiver, action.item?.user_id]
            : action.item?.role_id == 1
            ? state.receiver.map((r) => r)
            : state.receiver.filter((r) => r !== action.item?.user_id),
        };

      case "select":
        return {
          ...state,
          [action.payload.target.name]: action.payload.target.value,
        };
      case "date":
        return { ...state, issue_date: action.payload };
      case "receiver_all":
        return {
          ...state,
          allReceivers: action.payload,
          receiver: [action.payload.find((it) => it.role_id == 1).user_id],
        };

      default:
        return state;
    }
  };

  const [stateData, dispatch] = useReducer(updateStateFunc, initialState);

  const {
    callAnyApi,
    searchKey,
    record,
    pages,
    SearchApi,
    setRecord,
    allData,
    apiurl,
  } = useSearchListPagination();

  useEffect(() => {
    setRecord(30);
  }, []);

  useEffect(() => {
    callAnyApi(`/request/receiver/list`);
  }, [searchKey, record, pages]);

  const [errorMessage, setErrorMessage] = useState();

  const [tenantData, settenantData] = useState({});

  const [isDownload, setisDownload] = useState(false);
  const [istenantId, setistenantId] = useState("");
  const [prindtDta, setprindtDta] = useState([]);
  const [text, setText] = React.useState("old boring text");

  const componentRef = useRef();

  const route = useNavigate();
  const { isAuthenticated, userDetails } = useAuth();
  const [tenantdetails, setTenantDetails] = useState();
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [paymentShow, setPaymentShow] = useState(false);
  const handlepaymentClose = () => setPaymentShow(false);
  const handlepaymentShow = () => setPaymentShow(true);
  const [loading, setLoading] = useState(false);
  const [paymentsData, setpaymentsData] = useState([]);

  const [modals, setModals] = useState({
    payNowModal: false,
    payymentStatemnt: true,
    deleteModal: false,
    paymentsData: {},
  });

  const closeAllModals = () => {
    setModals({
      ...Object.keys(modals).reduce(
        (reduced, key) => ({ ...reduced, [key]: false }),
        {}
      ),
    });
  };

  const [statusShow, setStatus] = useState(false);

  const {
    onSelectFile,
    deleteHandler,
    uploadToserver,
    selectedImages,
    setSelectedImages,
    defaultImg,
    setdefaultImg,
    handleDefaultImage,
    ImgLinks,
    setImgLinks,
  } = useMultipleImgUpload();

  const [sharePartner, setSharepartner] = useState({
    is_sharable: false,
    TenantPartnerData: [
      {
        first_name: "",
        middle_name: "",
        last_name: "",
        phone_number: "",
        email: "",
      },
    ],
  });
  const { is_sharable } = sharePartner;

  let ManagerFullName = `${
    tenantdetails?.manager_first_name ? tenantdetails?.manager_first_name : ""
  } ${
    tenantdetails?.manager_middle_name ? tenantdetails?.manager_middle_name : ""
  } ${
    tenantdetails?.manager_last_name ? tenantdetails?.manager_last_name : ""
  }`;
  let OwnerFullName = `${
    tenantdetails?.owner_first_name ? tenantdetails?.owner_first_name : ""
  } ${
    tenantdetails?.owner_middle_name ? tenantdetails?.owner_middle_name : ""
  } ${tenantdetails?.owner_last_name ? tenantdetails?.owner_last_name : ""}`;

  useEffect(() => {
    setLoading(true);
    TenantFunc();
    axios
      .post("request/receiver/list")
      .then((response) => {
        if (response?.data) {
          dispatch({
            type: "receiver_all",
            payload: response.data?.result?.rows,
          });
          // dispatch({ type:"checkbox", payload:e,item:item})
          setLoading(false);
        }
      })
      .catch((e) => {
        setLoading(false);
      });
  }, [isAuthenticated]);

  const validation = (values) => {
    const errors = {};
    const allTextType = /^[a-zA-Z0-9' . - _ ! $ % @ & # ? : ; ^ ~,/*-]+$/;
    const onlyText = /^[a-zA-Z]+$/;
    const onlyNumber = /^[0-9]+$/;

    if (!stateData.task_title || !trim(stateData.task_title)) {
      errors.task_title = "Please enter your Task title.";
    }

    // if (requstsend?.length == 0) {
    //   errors.managerName = "Please choose at least one Receiver.";
    // }
    return errors;
  };

  const TaskFunc = (e) => {
    e.preventDefault();

    const Valid = validation();
    setErrorMessage(Valid);

    if (Object.keys(Valid).length == 0 && selectedImages.length < 11) {
      setLoading(true);
      if (selectedImages.length == 0) {
        taskFuncWithImg([]);
      } else {
        uploadToserver("request_image", setLoading).then((res) => {
          if (res?.data?.links) {
            taskFuncWithImg(res?.data?.links);
          }
        });
      }
    }
  };

  const taskFuncWithImg = (imagesss) => {
    let data = stateData;
    data = {
      ...stateData,
      request_image: JSON.stringify(imagesss),
    };

    axios
      .post("request/create", data)
      .then(function (response) {
        if (response.status === 200) {
          route("/requestlist");
          handleClose(false);
          setLoading(false);
        }
      })
      .catch(function (error) {
        setLoading(false);
      });
  };

  const TenantFunc = () => {
    setLoading(true);
    axios
      .get(`tenant/profile`)
      .then((response) => {
        if (response?.data) {
          const value = response?.data;
          if (value) {
            setTenantDetails(value?.[0]);
            setLoading(false);
          } else {
            setTenantDetails();
            setLoading(false);
          }
          if (
            value?.[1]?.is_sharable == null &&
            value?.[1]?.TenantPartnerData == null
          ) {
            setSharepartner({
              is_sharable: false,
              TenantPartnerData: [
                {
                  first_name: "",
                  middle_name: "",
                  last_name: "",
                  phone_number: "",
                  email: "",
                },
              ],
            });
          } else {
            // setSharepartner(value?.[1]);
          }
        }
      })
      .catch((e) => {});
    setLoading(false);
  };

  const SharepartnerChecked = (e) => {
    const { value, type } = e.target;
    if (type === "checkbox") {
      const value = e.target.checked;
      setStatus(!statusShow);
      setSharepartner({ ...sharePartner, is_sharable: value });
    }
  };

  const SharepartnerFunc = (e, index) => {
    const { value, name } = e.target;
    const list = sharePartner.TenantPartnerData;
    list[index][name] = value;
    setSharepartner({ ...sharePartner, TenantPartnerData: list });
  };
  const handleServiceRemove = (e, index) => {
    e.preventDefault();
    const list = sharePartner.TenantPartnerData;
    list.splice(index, 1);
    setSharepartner({ ...sharePartner, TenantPartnerData: list });
  };
  const handleServiceAdd = () => {
    const list = sharePartner.TenantPartnerData;
    list.push({
      first_name: "",
      middle_name: "",
      last_name: "",
      phone_number: "",
      email: "",
    });
    setSharepartner({ ...sharePartner, TenantPartnerData: list });
  };
  const SubmitHandler = (e) => {
    e.preventDefault();
    setLoading(true);
    axios
      .post("/tenant/create/tenant/partner", sharePartner)
      .then(function (response) {
        setLoading(false);
        if (response.status == 200) {
          toast.success("Create Successfully", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        } else {
          toast.warn("please fill up atleast one field", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      })
      .catch(function (error) {
        setLoading(false);
      });
  };

  const getPaymentStatement = async () => {
    setLoading(true);
    await axios
      .post(`/tenant/payment/history`, {
        page: 1,

        record: 30,
      })
      .then((res) => {
        setpaymentsData(res?.data.result);

        settenantData(res?.data.tenantdeatils);
      })
      .catch((err) => {})
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (istenantId) {
      setprindtDta("psadisaiudg");
      handlePrintData();
      setisDownload(true);
      handlePrint();
    }
  }, [istenantId]);
  const handlePrintData = async () => {
    setLoading(false);
    // await axios.get(`/accountant/Collection/tenant/details/${istenantId}`)
    //   .then(function (response) {
    //     if (response) {
    //       // return response;
    //       setprindtDta(response.data)
    //       // setText(response.data)

    //     }
    //   })
  };

  const onBeforeGetContentResolve = React.useRef(null);

  const handleAfterPrint = React.useCallback(() => {
    setLoading(false);
  }, []);

  const handleBeforePrint = React.useCallback(async () => {
    setText(prindtDta);

    // setText(prindtDta);
    setistenantId("");
  }, []);

  const handleOnBeforeGetContent = React.useCallback(() => {
    setText(prindtDta);
    setisDownload(true);

    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        // setLoading(false);
        setText("New, Updated Text!");
        resolve();
      }, 2000);
    });
  }, [setLoading, setText]);

  const reactToPrintContent = React.useCallback(() => {
    return componentRef.current;
  }, [componentRef.current]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: "AwesomeFileName",
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  React.useEffect(() => {
    if (
      text === "New, Updated Text!" &&
      typeof onBeforeGetContentResolve.current === "function"
    ) {
      onBeforeGetContentResolve.current();
      setText("old boring text");
      setisDownload(false);
    }
  }, [onBeforeGetContentResolve.current, text]);

  const payNowFunc = async () => {
    try {
      const datas = await axios.post(
        `accountant/Collection/tenant/rent/show/${tenantdetails?.tenant_id}`
      );

      setModals({
        ...Object.keys(modals).reduce(
          (reduced, key) => ({ ...reduced, [key]: false }),
          {}
        ),
        payNowModal: true,
      });
    } catch (error) {}
  };

  return (
    <DashboardLayouts>
      <ToastContainer />
      {(loading || allowLoading) && <Loader />}
      <div className="breadcrumb row justify-content-between align-items-center">
        <div className="d-flex align-items-center dashboard-upper-menu col-md-4 col-auto">
          <h2 className="mb-0 profile-heading fw-normal">Profile Details</h2>
        </div>
        <div className="col-auto btn-responsive">
          <button className="btn btn-outline-primary me-2" onClick={payNowFunc}>
            Payment Procedure
          </button>
          {/* <button
            className="btn btn-outline-primary me-2"
            onClick={() => {
              setModals({
                ...Object.keys(modals).reduce((reduced, key) => ({ ...reduced, [key]: false }), {}), deleteModal:true
              });
            
            }}
          >
            Delete Modal
          </button> */}
          <button
            className="btn btn-outline-primary me-2"
            onClick={() => {
              getPaymentStatement();
              handlepaymentShow();
            }}
          >
            Payment History
          </button>
          <Link
            variant="primary"
            className="btn btn-outline-primary me-2"
            to="/tenant-tasklist"
          >
            Task List
          </Link>
          <Link
            variant="primary"
            className="btn btn-outline-primary me-2"
            to="/requestlist"
          >
            Request List
          </Link>

          <button
            variant="primary"
            className="btn btn-outline-primary raise-btn"
            onClick={handleShow}
          >
            Raise Request
          </button>
        </div>
      </div>

      <section className="view-tenant-main row d-flex justfy-content-between mt-lg-5 mt-md-3 mt-2 mb-4">
        <div className="col-xxl-8 left manager-details-area view-tenant-list">
          <h3 className="heading-text">
            {tenantdetails?.first_name + " " + tenantdetails?.last_name}{" "}
          </h3>
          <ul className="d-flex flex-wrap mt-4">
            <li>
              <span>Building Name :</span>
              <p>{tenantdetails?.building_name}</p>
            </li>

            <li>
              <span>Appt Size :</span>
              <p>{tenantdetails?.apartment}</p>
            </li>

            <li>
              <span>Locker :</span>
              <p>{tenantdetails?.locker} </p>
            </li>
            <li>
              <span>Lease Start Date :</span>
              <p>{moment(tenantdetails?.lease_start_date).format("L")}</p>
            </li>

            <li>
              <span>Payment Mode :</span>
              <p>{tenantdetails?.payment_mode}</p>
            </li>

            <li>
              <span>Laundry Card Deposit :</span>
              <p>{tenantdetails?.laundry_deposit}</p>
            </li>

            <li>
              <span>Phone Number :</span>
              <p>{tenantdetails?.phone_number}</p>
            </li>

            <li>
              <span>Lease End Date :</span>
              <p>{moment(tenantdetails?.lease_end_date).format("L")}</p>
            </li>

            <li>
              <span>Parking & Other :</span>
              <p>{tenantdetails?.parking}</p>
            </li>

            <li>
              <span>Key Deposit :</span>
              <p>{tenantdetails?.key_deposit}</p>
            </li>

            <li>
              <span>Email :</span>
              <p>{tenantdetails?.email}</p>
            </li>

            <li>
              <span>Monthly Rent :</span>
              <p>{tenantdetails?.monthly_rent}</p>
            </li>

            <li>
              <span>Internet :</span>
              <p>{tenantdetails?.internet}</p>
            </li>

            <li>
              <span>Advance Rent :</span>
              <p>{tenantdetails?.advance_rent}</p>
            </li>
          </ul>
        </div>

        <div className="col-12 col-lg-auto right d-flex justify-content-center  align-items-center justify-content-lg-start flex-column">
          <div className="login-user">
            <img
              src={tenantdetails?.image ? tenantdetails?.image : DummyImg}
              alt=""
              className="profile_pic mb-lg-3 mb-md-2 mb-1"
            />
          </div>

          <p>
            Status :
            {tenantdetails?.status == "1" ? (
              <span style={{ color: "green" }} className="text-center">
                Active
              </span>
            ) : (
              <span style={{ color: "red" }} className="text-center">
                Inactive
              </span>
            )}
          </p>
        </div>
      </section>
      <div className="worker-dashboard worker-dashboard-2 row">
        <div className="worker-left col-md-6 col-lg-6">
          <div className="d-block d-sm-flex d-md-block d-lg-flex justify-content-between">
            <div className="worker-list1 ">
              <p className="heading-text">Owner Details</p>

              <ul className="d-flex flex-wrap mt-4">
                <li>
                  <span>Name</span>
                  <p>{OwnerFullName ? OwnerFullName : "N/A"}</p>
                </li>
              </ul>
              <ul className="d-flex flex-wrap">
                <li>
                  <span>Email</span>
                  <p>
                    {tenantdetails?.owner_email
                      ? tenantdetails?.owner_email
                      : "N/A"}
                  </p>
                </li>
                <li>
                  <span>Phone Number</span>
                  <p>
                    {tenantdetails?.owner_phone_number
                      ? tenantdetails?.owner_phone_number
                      : "N/A"}
                  </p>
                </li>
              </ul>
            </div>

            <div className="worker-img-area ">
              <div className="worker_img_wrapper">
                <div className="worker-image">
                  <img
                    src={
                      tenantdetails?.owner_image
                        ? tenantdetails?.owner_image
                        : DummyImg
                    }
                    alt=""
                    className="profile_pic mb-lg-3 mb-md-2 mb-1"
                  />
                </div>
                {/* <p>
                  Status :
                  <span
                    style={
                      tenantdetails?.owner_status == 1
                        ? { color: "green" }
                        : { color: "red" }
                    }
                    className="text-center"
                  >
                    {tenantdetails?.owner_status == "1"
                      ? " Active"
                      : " Inactive"}
                  </span>
                </p> */}
              </div>
            </div>
          </div>
        </div>
        <div className="worker-left col-md-6 col-lg-6">
          <div className="d-block d-sm-flex d-md-block d-lg-flex justify-content-between">
            <div className="worker-list1 ">
              <p className="heading-text">Building Manager Details</p>

              <ul className="d-flex flex-wrap mt-4">
                <li>
                  <span> Name</span>
                  <p>{ManagerFullName ? ManagerFullName : "N/A"}</p>
                </li>
              </ul>
              <ul className="d-flex flex-wrap">
                <li>
                  <span>Email</span>
                  <p>
                    {tenantdetails?.manager_email
                      ? tenantdetails?.manager_email
                      : "N/A"}
                  </p>
                </li>
                <li>
                  <span>Phone Number</span>
                  <p>
                    {tenantdetails?.manager_phone_number
                      ? tenantdetails?.manager_phone_number
                      : "N/A"}
                  </p>
                </li>
              </ul>
            </div>

            <div className="worker-img-area ">
              <div className="worker_img_wrapper">
                <div className="worker-image">
                  <img
                    src={
                      tenantdetails?.manager_image
                        ? tenantdetails?.manager_image
                        : DummyImg
                    }
                    alt=""
                    className="profile_pic mb-lg-3 mb-md-2 mb-1"
                  />
                </div>
                {/* <p>
                  Status :
                  <span
                    style={
                      tenantdetails?.manager_status == 1
                        ? { color: "green" }
                        : { color: "red" }
                    }
                    className="text-center"
                  >
                    {tenantdetails?.manager_status == "1"
                      ? " Active"
                      : " Inactive"}
                  </span>
                </p> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="toggl-switch d-flex align-items-center justify-content-start">
        <p className="mb-0">Is It Sharable :</p>
        <label className="switch">
          <input
            type="checkbox"
            className="switch-input"
            name="is_sharable"
            value={is_sharable}
            checked={statusShow ? true : is_sharable}
            onChange={(e) => {
              SharepartnerChecked(e);
            }}
          />
          <span className="switch-label" data-on="On" data-off="Off"></span>
          <span className="switch-handle"></span>
        </label>
      </div>
      <div className="add-request-form w-100 mt-4">
        {is_sharable && (
          <form action="" className="dash-form add-form add-building-area">
            <div className="row">
              <div className="col-xl-12">
                {sharePartner?.TenantPartnerData?.map((setvalue, index) => (
                  <div className="row gy-2 gy-lg-4 gx-xl-5" key={index}>
                    <div className="col-xl-4 col-md-6 mb-2">
                      <div className="form-group">
                        <label htmlFor="" className="form-lbl">
                          First Name
                        </label>
                        <input
                          type="text"
                          className="form-control form-g1"
                          id="form-request*"
                          name="first_name"
                          onChange={(e) => SharepartnerFunc(e, index)}
                          value={setvalue.first_name}
                          placeholder="First Name"
                        />
                      </div>
                    </div>
                    <div className="col-xl-4 col-md-6 mb-2">
                      <div className="form-group">
                        <label htmlFor="" className="form-lbl">
                          Middle Name
                        </label>
                        <input
                          type="text"
                          className="form-control form-g1"
                          id="form-request*"
                          name="middle_name"
                          value={setvalue.middle_name}
                          onChange={(e) => SharepartnerFunc(e, index)}
                          placeholder="Middle Name"
                        />
                      </div>
                    </div>
                    <div className="col-xl-4 col-md-6 mb-2">
                      <div className="form-group">
                        <label htmlFor="" className="form-lbl">
                          Last Name
                        </label>
                        <input
                          type="text"
                          className="form-control form-g1"
                          id="form-request*"
                          name="last_name"
                          value={setvalue.last_name}
                          onChange={(e) => SharepartnerFunc(e, index)}
                          placeholder="Last Name"
                        />
                      </div>
                    </div>
                    <div className="col-xl-4 col-md-6 mb-2">
                      <div className="form-group">
                        <label htmlFor="" className="form-lbl">
                          Phone Number
                        </label>
                        <input
                          type="text"
                          className="form-control form-g1"
                          id="form-request*"
                          name="phone_number"
                          value={setvalue.phone_number}
                          onChange={(e) => SharepartnerFunc(e, index)}
                          placeholder="Phone Number"
                        />
                      </div>
                    </div>
                    <div className="col-xl-8 col-md-12 mb-2">
                      <div className="form-group">
                        <label htmlFor="" className="form-lbl">
                          Email
                        </label>
                        <input
                          type="text"
                          className="form-control form-g1"
                          id="form-request*"
                          name="email"
                          value={setvalue.email}
                          onChange={(e) => SharepartnerFunc(e, index)}
                          placeholder="Email"
                        />
                      </div>
                    </div>

                    {sharePartner.TenantPartnerData.length !== 1 && (
                      <div className="pb-4 mb-3 col-sm-3 col-xl-2 d-flex align-items-end">
                        <button
                          className="px-3 py-2 border fw-bold d-flex align-items-center justify-content-center text-4 from_input rounded-2"
                          onClick={(e) => handleServiceRemove(e, index)}
                        >
                          REMOVE
                        </button>
                      </div>
                    )}
                    {sharePartner.TenantPartnerData.length - 1 === index &&
                      sharePartner.TenantPartnerData.length < 100 && (
                        <>
                          <div className="pb-4 mb-3 col-sm-2 col-lg-1 d-flex align-items-end">
                            <button
                              className="px-3 py-2 border fw-bold d-flex align-items-center justify-content-center text-4 from_input rounded-2"
                              onClick={handleServiceAdd}
                            >
                              ADD
                            </button>
                          </div>
                        </>
                      )}
                    {sharePartner.TenantPartnerData.length - 2 === index ? (
                      <hr className="mb-3" />
                    ) : (
                      ""
                    )}
                  </div>
                ))}
                <div className="col-xl-12 col-md-12 mt-4 col-md-6">
                  <button
                    type="button"
                    className="btn btn-primary btn-lg form-btn add-building-btn"
                    onClick={(e) => {
                      SubmitHandler(e);
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </form>
        )}
      </div>

      <Modal
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={show}
        onHide={handleClose}
        className="Raise-rq-modal-popup"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h4 className="heading-text fw-bold mb-0">Raise Request</h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {true ? (
            <form action="" className="add-form add-building-area row">
              {loading ? (
                <Loader />
              ) : (
                <>
                  <div className="col-lg-8">
                    <div className="row">
                      <div className="col-xl-6 col-md-6 mb-3">
                        <div className="form-group">
                          <label htmlFor="" className="form-lbl">
                            Task Title
                          </label>
                          <input
                            type="text"
                            name="task_title"
                            value={stateData?.task_title}
                            onChange={(e) => {
                              dispatch({ type: "input", payload: e });
                            }}
                            className="form-control form-g1"
                            id="form-request*"
                          />

                          {errorMessage?.task_title ? (
                            <div
                              className="error error-message"
                              style={{ color: "red" }}
                            >
                              {errorMessage?.task_title}
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>

                      <div className="col-xl-6 col-md-6 mb-3">
                        <div className="form-group">
                          <label htmlFor="" className="form-lbl">
                            Choose Task Category
                          </label>

                          <select
                            type="text"
                            name="task_category"
                            value={stateData?.task_category}
                            onChange={(e) => {
                              dispatch({ type: "input", payload: e });
                            }}
                            className="form-control form-g1"
                            id="form-request*"
                          >
                            <option value="">Choose</option>
                            <option value="Maintenance">Maintenance</option>
                            <option value="Accounts">Accounts</option>
                            <option value="Security">Security</option>
                            <option value="Legal">Legal</option>
                          </select>
                        </div>
                      </div>

                      <div className="col-xl-6 col-md-6 mb-3">
                        <div className="form-group">
                          <label htmlFor="" className="form-lbl">
                            Sub Task Category
                          </label>

                          <select
                            type="text"
                            name="sub_task_category"
                            value={stateData?.sub_task_category}
                            onChange={(e) => {
                              dispatch({ type: "input", payload: e });
                            }}
                            className="form-control form-g1"
                            id="form-request*"
                          >
                            {!isEmpty(stateData?.task_category) ? (
                              stateData?.task_category == "Maintenance" ? (
                                <>
                                  <option value="">Choose</option>
                                  <option value="Plumbing">Plumbing</option>
                                  <option value="Electrical">Electrical</option>
                                  <option value="Cleaning">Cleaning</option>
                                  <option value="Fire alarm/Smoke detector">
                                    Fire alarm/Smoke detector
                                  </option>
                                  <option value="Painting">Painting</option>
                                  <option value="General work">
                                    General work
                                  </option>
                                </>
                              ) : (
                                <>
                                  <option value="">Choose</option>
                                  <option value="Option-1">Option-1</option>
                                  <option value="Option-2">Option-2</option>
                                  <option value="Option-3">Option-3</option>
                                </>
                              )
                            ) : (
                              <option value="null">Choose sub category</option>
                            )}
                          </select>
                        </div>
                      </div>

                      <div className="col-xl-6 col-md-6 mb-3">
                        <div className="form-group">
                          <label htmlFor="" className="form-lbl">
                            Request Date
                          </label>
                          {/* <input
                      type="date"
                      name="issue_date"
                      value={issue_date}
                      onChange={(e) => }
                      className="form-control form-g1"
                      id="form-request*"
                    // placeholder="Country"
                    /> */}

                          <DatePicker
                            selected={stateData?.issue_date}
                            onChange={(date) => {
                              dispatch({ type: "date", payload: date });
                            }}
                            minDate={new Date()}
                            required
                            className="form-control form-g1"
                          />
                        </div>
                      </div>

                      <div className="col-xl-6 col-md-6 mb-3">
                        <div className="form-group">
                          <label htmlFor="" className="form-lbl">
                            Choose Receivers :
                          </label>
                        </div>
                      </div>
                      <div className="col-xl-12 col-md-12 mb-3">
                        <div className="form-group">
                          {stateData?.allReceivers?.map((item, i) => {
                            return (
                              <>
                                <input
                                  type="checkbox"
                                  name="receivers"
                                  value={item?.user_id}
                                  // disabled={stateData?.allReceivers?.find(itmm=>item.role_id==1)}
                                  className="me-1"
                                  checked={stateData?.receiver?.includes(
                                    item?.user_id
                                  )}
                                  // onChange={(e) => handleRequstTo(e, item)}

                                  // value={stateData?.sub_task_category}
                                  onChange={(e) => {
                                    dispatch({
                                      type: "checkbox",
                                      payload: e,
                                      item: item,
                                    });
                                  }}
                                />
                                <label className="pr-3">
                                  {item.User?.first_name} {item.User?.last_name}{" "}
                                  {item?.role_id == 3
                                    ? "(Tenant)"
                                    : "" || item?.role_id == 2
                                    ? "(Manager)"
                                    : "" || item?.role_id == 1
                                    ? "(Owner)"
                                    : "" || item?.role_id == 4
                                    ? "(Worker)"
                                    : "" || item?.role_id == 5
                                    ? "(Partner)"
                                    : "" || item?.role_id == 6
                                    ? "(Accountant)"
                                    : ""}
                                </label>
                              </>
                            );
                          })}

                          {errorMessage?.managerName ? (
                            <div
                              className="error error-message"
                              style={{ color: "red" }}
                            >
                              {errorMessage?.managerName}
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>

                      <div className="col-xl-12">
                        <div className="form-group">
                          <label htmlFor="" className="form-lbl">
                            Description
                          </label>
                          <textarea
                            className="form-control form-g1"
                            type="text"
                            name="description"
                            value={stateData?.description}
                            onChange={(e) => {
                              dispatch({ type: "input", payload: e });
                            }}
                            id="form-request*"
                            placeholder="Description"
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                  <GallaryBox
                    selectedImages={selectedImages}
                    defaultImg={defaultImg}
                    handleDefaultImage={handleDefaultImage}
                    onSelectFile={onSelectFile}
                    deleteHandler={deleteHandler}
                  />

                  <div className="w-100">
                    <div className="d-flex mt-md-5">
                      {/* <button
                    className="skip-btn"
                    onClick={() => {
                      setShow(false);
                    }}
                  >
                    Cancel
                  </button> */}
                      <button
                        className="btn btn-primary"
                        onClick={(e) => {
                          TaskFunc(e);
                        }}
                      >
                        Request now
                      </button>
                    </div>
                  </div>
                </>
              )}
            </form>
          ) : (
            <p className="text-center text-danger">Please active the Tenant</p>
          )}
        </Modal.Body>
      </Modal>

      <Modal
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={paymentShow}
        onHide={handlepaymentClose}
        className="tenant-payment-modal-popup"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <>
            <div
              ref={componentRef}
              className={isDownload ? "container m-2 " : "container"}
            >
              <div className="col-md order-1 order-xl-2">
                <ul className="d-flex flex-wrap">
                  <li className=" list-info">
                    <span>Tenant Name:</span>
                    <p>{`${tenantdetails?.first_name} ${tenantdetails?.middle_name}  ${tenantdetails?.last_name} `}</p>
                  </li>

                  <li className=" list-info">
                    <span>Unit Name :</span>
                    <p>{tenantdetails?.unit_name}</p>
                  </li>
                  <li className=" list-info">
                    <span>Duration :</span>

                    <p>{record > 90 ? "90+" : record}</p>
                  </li>
                </ul>
              </div>
              <div className="list-data ">
                <h1 className="heading-text mb-4">
                  View All Payment statement
                </h1>

                <div
                  className={
                    isDownload
                      ? "d-none"
                      : " data-filters d-flex justify-content-between align-items-center mb-4 flex-nowrap"
                  }
                >
                  <div className="page-records d-flex align-items-center">
                    <form action="" className="number">
                      <select
                        className="number-box"
                        value={record}
                        name="record"
                        onChange={(event) => {
                          setRecord(event.target.value);
                        }}
                      >
                        <option value="30">30</option>
                        <option value="60">60</option>
                        <option value="90">90</option>
                        <option value="99999999">More than 90</option>
                      </select>
                    </form>

                    <h3 className="mb-0 ms-2 d-none d-sm-block">
                      Days Records{" "}
                    </h3>
                  </div>

                  <div className="form search-bar1 d-flex justify-content-end ms-3">
                    <li className="tex-center">
                      <button
                        onClick={handlePrint}
                        className="btn btn-outline-primary"
                      >
                        Print
                      </button>
                    </li>
                  </div>
                </div>
              </div>
              <div className="w-100 table-content overflow-auto">
                <table className="w-100">
                  <thead>
                    <tr>
                      <th>Transaction Date</th>
                      <th> Transaction Type</th>
                      <th> Amount </th>
                      <th>Transaction No.</th>

                      <th className="tex-center"> Balance</th>
                    </tr>
                  </thead>

                  <tbody>
                    {allData?.length > 0 ? (
                      allData?.slice(0, record).map((items, i) => {
                        return (
                          <tr key={i} className={`border-b`}>
                            <td className="">
                              <p>
                                {" "}
                                {moment(items.cash_collected_date).format(
                                  "1/MM/YYYY"
                                )}
                              </p>

                              <p>
                                {" "}
                                {moment(items.cash_collected_date).format("L")}
                              </p>
                            </td>
                            <td className="">
                              {" "}
                              <p>Statement</p> <p>Payment </p>{" "}
                            </td>

                            <td className="">
                              <p>
                                {" "}
                                {Number(items.Collected_Amount) +
                                  Number(items.balance)}
                              </p>
                              <p>- {items.Collected_Amount}</p>
                            </td>

                            <td className=""> {items.transaction_id}</td>

                            <td> {items.balance}</td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="8" className="text-center">
                          No Data Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              <div className="w-100 table-content overflow-auto">
                <table className="w-100">
                  <thead>
                    <tr>
                      <th>Remaining Balance : </th>

                      <th> </th>
                      <th> </th>
                      <th> </th>
                      <th> </th>
                      <th></th>
                      <th className="text-center">
                        {allData.length !== 0
                          ? allData[allData?.length - 1].balance
                          : 0}{" "}
                      </th>
                    </tr>
                  </thead>
                  {/* <tbody>

                        <tr>
                            <td className="">07/01/2022 07/01/2022</td>
                            <td className="">21000</td>
                            <td className="">Payment Statement</td>
                        </tr>
                    </tbody> */}
                </table>
              </div>
            </div>
          </>
        </Modal.Body>
      </Modal>

      <PaymentModal
        show={modals.payNowModal}
        handleClose={closeAllModals}
        tenantdetails={tenantdetails}
      />
      <DeleteModal show={modals.deleteModal} handleClose={closeAllModals} />
    </DashboardLayouts>
  );
}
export default Tenantdashboard;
